import { ApolloClient, InMemoryCache } from "@apollo/client"

const client = new ApolloClient({
    uri: "https://wp.awardsinternational.com/graphql",
    cache: new InMemoryCache()
})

export default client